<div class="mx-auto px-4">
  <p class="titre1">
    {{ 'CONTENUS_MANAGEMENT.PAGE_CONTENUS_MANAGEMENT' | translate }}
    <mat-icon class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">monitoring</mat-icon>
  </p>
  <div class="mx-auto">
    <div class="overflow-x-auto">
      <h2 class="mb-2">
        <p id="gestion-contenus-evenement-session" class="titre2">
          {{ 'CONTENUS_MANAGEMENT.PAGE_CONTENUS_EVENEMENT_SESSION' | translate }}
        </p>
      </h2>
    </div>
    @if (isLoading) {
      <div class="flex justify-center items-center h-64">
        <mat-spinner color="accent"></mat-spinner>
      </div>
    }
    @if (!isLoading) {
      <h2 class="titre2">{{ 'CONTENUS_MANAGEMENT.TITRE_FORMATION' | translate }} "{{detailSession.titreFormation}}"</h2>
      <h4 class="titre4">{{ 'CONTENUS_MANAGEMENT.PRENOM_NOM_UTILISATEUR' | translate }} {{detailSession.nomUtilisateur}} {{detailSession.dateDebut | date:'YYYY-MM-dd hh:mm:ss' }} {{ 'CONTENUS_MANAGEMENT.SESSIONID' | translate }} {{detailSession.sessionId }}</h4>
      <div class="flex justify-end items-center mb-4">
        <div class="flex flex-col gap-2">
          <div class="flex items-center gap-2">
            <input type="text" [(ngModel)]="textRechercher" (ngModelChange)="filtre()"
              placeholder="{{ 'CONTENUS_MANAGEMENT.SEARCH' | translate }}..."
              class="h-8 w-46 rounded-md border-gray-300 shadow-sm focus:border-red-300 focus:ring focus:ring-red-200">
              <button mat-icon-button (click)="reinitialiserFiltre()"
                class="h-5 w-8 bg-white-200 text-white-600 rounded">
                <mat-icon>restore</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="w-full overflow-x-auto">
          <table mat-table [dataSource]="dataSource" matSort class="mat-table-novo" (matSortChange)="sortDataChange($event)">
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2">{{ 'CONTENUS_MANAGEMENT.SESSIONID' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b">{{element.id |tiret}} </td>
            </ng-container>
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2"> {{ 'CONTENUS_MANAGEMENT.TYPE' | translate
              }}</th>
              <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b"> {{element.type | tiret  }} </td>
            </ng-container>
            <ng-container matColumnDef="duree">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2">{{ 'CONTENUS_MANAGEMENT.TIME' | translate
              }}</th>
              <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b"> {{ element.duree | tiret }} </td>
            </ng-container>
            <ng-container matColumnDef="reponse">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2"> {{ 'CONTENUS_MANAGEMENT.REPONSE' | translate }}</th>
              <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b"> {{ element.reponse| tiret}} </td>
            </ng-container>
            <ng-container matColumnDef="resultat">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2"> {{ 'CONTENUS_MANAGEMENT.RESULTAT' | translate }}</th>
              <td *matCellDef="let element" class="table-cell px-4 py-2">
                <span [ngClass]="{'bg-green-700': element.resultat === 'correct', 'bg-red-700': element.resultat === 'incorrect'}" class="inline-block whitespace-nowrap bg-green-700 rounded-full px-3 py-1 text-sm text-white-700 mr-2">{{ element.resultat | tiret}}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="dateEvenement">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="hidden md:table-cell px-4 py-2">{{ 'CONTENUS_MANAGEMENT.DATE_EVENEMENT' | translate }}</th>
              <td mat-cell *matCellDef="let element" class="hidden md:table-cell px-4 py-2 border-b"> {{ moment(element.dateEvenement).local().format('YYYY-MM-DD HH:mm') | tiret }} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
          </table>
          @if (dataSource.filteredData.length === 0) {
            <div class="text-center mt-2 text-gray-500">
              {{ 'COMMUN.DATATABLE_AUCUN_RESULTAT' | translate }}
            </div>
          }
          <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [pageIndex]="pageIndex"
            (page)="paginer($event)" [length]="totalItems" [showFirstLastButtons]="true">
          </mat-paginator>
        </div>
        <div class="flex justify-end">
          <a (click)="Retour()">
            <button class="btn-secondary-novo">Retour</button>
          </a>
        </div>
      }
    </div>
  </div>
